module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_jp_m.13a8dc7370380950b1a64bd949837bec.png";